import { Card, Col, Row } from "react-bootstrap";
import { vendorString } from "../../../../utils/string";
const BasicDetails = (props: any) => {
  return (
    <>
      <Card>
        <Card.Header className="bg-light align-items-center">
          <h3 className="fs-22 fw-bolder mb-0">Basic Details</h3>
        </Card.Header>
        <Card.Body>
          <Row className="gy-7">
            <Col lg={6}>
              <Row className="align-items-center">
                <Col sm={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    {vendorString.BusinessName}:
                  </label>
                </Col>
                <Col sm={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {props?.basicDetails?.businessName
                      ? props?.basicDetails?.businessName
                      : "-"}
                  </span>
                </Col>
              </Row>
            </Col>

            <Col lg={6}>
              <Row className="align-items-center">
                <Col sm={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    {vendorString.VendorName}:
                  </label>
                </Col>
                <Col sm={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {props?.basicDetails?.name
                      ? props?.basicDetails?.name
                      : "-"}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="align-items-center">
                <Col sm={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    {vendorString.PhoneNumber}:
                  </label>
                </Col>
                <Col sm={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {props?.basicDetails?.phone
                      ? props?.basicDetails?.phoneCountry +
                        " " +
                        props?.basicDetails?.phone
                      : "-"}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="align-items-center">
                <Col sm={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    {vendorString.Email}:
                  </label>
                </Col>
                <Col sm={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {props?.basicDetails?.email
                      ? props?.basicDetails?.email
                      : "-"}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="align-items-center">
                <Col sm={4}>
                  <label className=" fs-16 fw-500 text-dark">
                    {vendorString.Category}:
                  </label>
                </Col>
                <Col sm={8}>
                  <span className="fw-bolder fs-16 fw-600 text-dark">
                    {props?.basicDetails?.category?.name
                      ? props?.basicDetails?.category?.name
                      : "-"}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col lg={6}>
              <Row className="align-items-center">
                <Col sm={4}>
                  <label className="fs-16 fw-500 text-dark">
                    {vendorString.SubCategory}:
                  </label>
                </Col>
                <Col sm={8}>
                  <div className="d-flex flex-wrap align-items-center gap-2">
                    {props.basicDetails?.subCategory?.length > 0 ? (
                      <>
                        {props.basicDetails?.subCategory?.map((item: any) => {
                          return (
                            <span className="bg-light-primary rounded-1 p-3 fw-600 text-black fs-16 me-2">
                              {item.name}
                            </span>
                          );
                        })}
                      </>
                    ) : (
                      "-"
                    )}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <div className="card table-out mt-5">
        <div className="card-header bg-light border-2 pt-2">
          <h3 className="card-title card-label fs-22 fw-bolder fw-bold text-dark">
            {vendorString.Address}
          </h3>
        </div>
        <div className="card-body">
          <Row>
            <Col lg={12} className="pt-2">
              <Card>
                <div className="d-flex align-items-center mb-8 customer">
                  <div className="flex-grow-1 ms-5 pt-5 ">
                    <span className=" fw-bold fs-16">Business Address</span>
                    <span className=" fw-bold fs-16 d-block">
                      {props?.basicDetails?.address
                        ? props?.basicDetails?.locality +
                          ", " +
                          props?.basicDetails?.address
                        : "-"}
                    </span>
                  </div>
                  {/* <div className="flex-grow-3 ms-5 text-align-center">
                    <span className="badge badge-light custom-badge text-dark-800 fw-bold fs-6 d-center-block">
                   
                    </span>
                  </div> */}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
export { BasicDetails };
